import { Directive, HostBinding, HostListener, output } from '@angular/core'

@Directive({
  selector: '[libFileDrag]',
})
export class FileDragDirective {
  @HostBinding('class.dd-over') isOver = false

  filesDropped = output<FileList>()

  @HostListener('dragover', ['$event'])
  onDragOver(evt: DragEvent) {
    evt.preventDefault()
    evt.stopPropagation()
    this.isOver = true
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(evt: DragEvent) {
    evt.preventDefault()
    evt.stopPropagation()
    this.isOver = false
  }

  @HostListener('drop', ['$event'])
  onDrop(evt: DragEvent) {
    evt.preventDefault()
    evt.stopPropagation()
    this.isOver = false
    const files = evt.dataTransfer?.files
    if (files && files.length > 0) {
      this.filesDropped.emit(files)
    }
  }
}
